module.exports = __webpack_public_path__ + "img/num5_joy.c623612b.png";